import { createInertiaApp } from '@inertiajs/react'

import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '../styles/application.scss'

void createInertiaApp({
  pages: "../pages",

  serverHead: true,

  title: (title) => (title ? `${title} · LuxLector` : "LuxLector"),

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
